module.exports = __webpack_public_path__ + "img/douyinhao.a8d21b60.png";